import { useState, useEffect } from 'react';
import { formatLeetCodeData, OWNER, LEET_CODE_REPO, REPO_MD_FILE } from '../utils/DataParser';
import { octokit } from '../utils/OctoKit';

import LeetCodeTable from '../components/DataTables/LeetCodeTable';

export default function LeetCodeView() {
  const [data, setData] = useState();
  
  useEffect(() => {
    const fetchLeetCodeData = async () => {
      await octokit.request(
        'GET /repos/{owner}/{repo}/contents/{path}',
        {
          owner: OWNER,
          repo: LEET_CODE_REPO,
          path: REPO_MD_FILE
        }
      ).then(response => {
        const encoded = response.data.content;
        const decoded = atob(encoded);
        const formatedData = formatLeetCodeData(decoded);
        setData(formatedData);
      }).catch(error => console.log(error));
    }
    fetchLeetCodeData();
  }, [])

  return !data ?
  (
    <>
    </>
  )
  :
  (
    <>
      <div>
        <LeetCodeTable leetCodeData={data}/>
      </div>
    </>
  )
}